import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import LinkButton from "components/ui/LinkButton";

import { useConfigContext } from "context/config";

function Dashboard() {
    const config = useConfigContext();

    return (
        <GridColumn>
            <GridRow justifyContent={"center"}>
                <GridItem className={"col-xs-12-8"}>
                    <Paper className={"dashboard-paper"}>
                        <GridRow justifyContent={"center"}>
                            <GridItem className={"dashboard-title"}>
                                <h2>{"COSA VUOI MODIFICARE?"}</h2>
                            </GridItem>
                        </GridRow>

                        <GridRow justifyContent={"center"}>
                            {config.features.indexOf("prodotti") !== -1 && (
                                <GridItem>
                                    <LinkButton
                                        to={"/gestione-prodotti/prodotti"}
                                        label={"Prodotti"}
                                    />
                                </GridItem>
                            )}

                            {config.features.indexOf("materiali") !== -1 && (
                                <GridItem>
                                    <LinkButton
                                        to={"/gestione-materiali/materiali"}
                                        label={"Materiali"}
                                    />
                                </GridItem>
                            )}

                            {config.features.indexOf("news") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/news"} label={"News"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("showroom") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/showroom"} label={"Showroom"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("cataloghi") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/cataloghi"} label={"Cataloghi"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("lavora-con-noi") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/lavora-con-noi"} label={"Lavora con noi"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("progetti") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/progetti"} label={"Progetti"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("tariffe") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/tariffe"} label={"Tariffe"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("offerte-speciali") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/offerte-speciali"} label={"Offerte Speciali"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("cm-documenti") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/cm-documenti"} label={"Documenti"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("cm-notizie") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/cm-notizie"} label={"Notizie"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("partner") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/partners"} label={"Partners"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("popup") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/popup"} label={"Popup"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("pagine") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/pagine"} label={"Pagine"} />
                                </GridItem>
                            )}

                            {config.features.indexOf("template") !== -1 && (
                                <GridItem>
                                    <LinkButton to={"/templates"} label={"Template"} />
                                </GridItem>
                            )}
                        </GridRow>
                    </Paper>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default Dashboard;
